import React, { Fragment } from "react";
import Logger from "../utils/Logger";
import g from "../utils/globals";

const logger = new Logger(__filename);

export const getExtensions = (element, extension) => {
  if (!element.extensions) element.extensions = {};
  if (!element.extensions.layers) element.extensions = { layers: {} };
  if (!element.extensions.layers[element.id]) {
    element.extensions.layers[element.id] = {};
  }
  if (!element.extensions.layers[element.id][extension]) {
    element.extensions.layers[element.id][extension] = {};
  }
  return element.extensions.layers[element.id][extension];
};

export const getCollage = () => {
  const itemSelected = document.querySelector(".item-selected");
  if (itemSelected) return itemSelected.getAttribute("data-content");
  return null;
};

export const getCompositionName = element => {
  const path = element.xmedia.path.split("/").filter(x => x);
  const content = path.pop();
  const project = path.pop();
  return `${project}-${content}`;
};

export const carouselPause = () => {
  if (window.selectedCarousel) {
    window.selectedCarousel.autoplay.stop();
    document.querySelector(".fa-play").classList.remove("active");
    document.querySelector(".fa-pause").classList.add("active");
  }
};

export const carouselStart = () => {
  const pauseButton = document.querySelector(".fa-pause");
  if (pauseButton && pauseButton.classList.contains("active")) {
    pauseButton.classList.remove("active");
    document.querySelector(".fa-play").classList.add("active");
    window.selectedCarousel.autoplay.start();
  }
};

export const carouselCheckControls = () => {
  if (window.selectedCarousel) {
    const pauseButton = document.querySelector(".fa-pause");
    const playButton = document.querySelector(".fa-play");
    if (window.selectedCarousel.autoplay.running) {
      pauseButton.classList.remove("active");
      playButton.classList.add("active");
    } else {
      pauseButton.classList.add("active");
      playButton.classList.remove("active");
    }
  }
};

export const goToSlide = (key = 0, self = {}) => {
  carouselPause();
  if (window.selectedCarousel.realIndex !== key) {
    if (self.saveData) self.saveData();
    window.selectedCarousel.slideTo(key + 1, 500);
  }
};

export const getModuleInfo = props => {
  if (props.kind === "image" || props.module === "Img" || props.module === "Video") {
    if (
      (props.extensions &&
        props.extensions.layers &&
        props.extensions.layers[props.id] &&
        props.extensions.layers[props.id].video &&
        props.extensions.layers[props.id].video.isVideo) ||
      props.module === "Video"
    ) {
      // config = extensions.layers[props.id].video;
      return (
        <Fragment>
          <i className="fas fa-film" /> {props.id.toUpperCase()}
        </Fragment>
      );
    }
    return (
      <Fragment>
        <i className="fas fa-image" /> {props.id.toUpperCase()}
      </Fragment>
    );
  } else if (props.kind === "text" || props.module === "Text") {
    return (
      <Fragment>
        <i className="fas fa-t" /> {props.id.toUpperCase()}
      </Fragment>
    );
  }
  logger.error(`Falta añadir: ${props.module}`);
  return (
    <Fragment>
      <i className="far fa-question-circle" /> {props.id.toUpperCase()}
    </Fragment>
  );
};

export const cleanExtensions = (extensions, _self) => {
  if (extensions.layers && extensions.layers[_self.state.props.id]) {
    const extension = extensions.layers[_self.state.props.id];
    if (extension.bounds && Object.keys(extension.bounds).length < 1) {
      Reflect.deleteProperty(extension, "bounds");
    }
    if (extension.video && !extension.video.isVideo) {
      Reflect.deleteProperty(extension, "video");
    }
    if (extension.shareClasses && extension.shareClasses.length < 1) {
      Reflect.deleteProperty(extension, "shareClasses");
    }
    if (extension.styles && Object.keys(extension.styles).length < 1) {
      Reflect.deleteProperty(extension, "styles");
    }
    if (extension.meta && !extension.meta.contents) {
      Reflect.deleteProperty(extension, "meta");
    }
  }
  return extensions;
};

export const removeSelected = () => {
  const previous = document.querySelector(".item-selected");
  if (previous) previous.classList.remove("item-selected");
};

export const handleToggle = (target, form = true) => {
  const element = form ? document.getElementById(`frm-${target}`) : document.getElementById(`${target}`);
  if (element) element.classList.toggle("hide");

  document.querySelectorAll("#bottom-bar form").forEach(x => {
    if (!element || (element && element.id !== x.id)) {
      x.classList.add("hide");
    }
  });

  const icon = document.getElementById(`icon-${target}`);
  if (icon && icon.classList.contains("fa-chevron-down")) {
    icon.classList.remove("fa-chevron-down");
    icon.classList.add("fa-chevron-up");
  } else if (icon && icon.classList.contains("fa-chevron-up")) {
    icon.classList.remove("fa-chevron-up");
    icon.classList.add("fa-chevron-down");
  }
};

export const addClasses = (config = {}, selectionMode = true) => {
  const body = document.body.classList;
  if (config) {
    document.querySelector("html").classList.add("edit-mode");
    body.add("marketing-page");
    body.add(config.id);
  }
  if (!g.channels.desktop) {
    body.add("home-mobile-module");
  } else {
    body.remove("home-mobile-module");
  }
  if (selectionMode) {
    body.add("selection-mode");
  } else {
    body.remove("selection-mode");
  }
};

export const cleanProps = (e, _self = this) => {
  if (!e.target.classList.contains("menu-group-button") && _self) {
    if (_self.state.changed) {
      _self.saveData();
    } else {
      _self.setState({
        props: null,
      });
    }
  }
};

export const selectSlideChangedCarousel = () => {
  // .${window.currentCarousel}
  if (g.editMode && document.querySelector(`.slide-btn`) && window.selectedCarousel.el.parentElement.id === window.currentCarousel) {
    const currentCarousel = `[data-content='${window.currentCarousel}']`;
    document.querySelectorAll(`${currentCarousel} .slide-btn`).forEach(x => x.classList.remove("selected"));
    document
      .querySelectorAll(`${currentCarousel} .slide-btn-${window.selectedCarousel.realIndex || 0}`)
      .forEach(x => x.classList.add("selected"));
    document.querySelectorAll(`${currentCarousel}  .carousel-selected`).forEach(x => {
      const selected = document.querySelector(`${currentCarousel} #frm-slides p.selected`);
      if (x.innerText && selected) x.innerText = selected.innerText;
    });
    // this is for selected slide extensions
    document.querySelectorAll(`${currentCarousel}  #selected-slide-extensions div.selected-carousel-extensions`).forEach(x => {
      x.classList.add("hide");
    });

    // we find the new one
    const extension = document.querySelector(`${currentCarousel} #selected-carousel-index-${window.selectedCarousel.realIndex || 0}`);
    if (extension) extension.classList.remove("hide");
    carouselCheckControls();
  }
};

export const isCarousel = (data = { contents: [] }) =>
  Boolean(data.contents.find(x => x.module === "CarouselVertical" || x.module === "Carousel"));
